module.exports = __webpack_public_path__ + "img/izu_logo.f8c60ab5.jpg";